import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home'
const AsyncCompanyOffer = () => import('./views/CompanyOffer')
const AsyncAbout = () => import('./views/About')
const AsyncContact = () => import('./views/Contact')

Vue.use(Router)

export default new Router({
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	linkActiveClass: 'menu-parent',
	linkExactActiveClass: 'menu-active',
	mode: 'history',
	routes: [
		{ path: '*', redirect: '/' },
		{
			path: '/',
			name: 'root',
			component: Home,
		},
		{
			path: '/home',
			redirect: '/',
		},
		{
			path: '/offer',
			name: 'offer',
			alias: '/oferta',
			component: AsyncCompanyOffer,
		},
		{
			path: '/about',
			name: 'about',
			alias: '/o-nas',
			component: AsyncAbout,
		},
		{
			path: '/contact',
			name: 'contact',
			alias: '/kontakt',
			component: AsyncContact,
		},
	],
})
